import { Component } from '@wordpress/element';
import { cloneDeep } from 'lodash';
import App, { AppContext } from '../App';
import { RestrictedView, ResultGrid, ResultControls, ResultSelected } from './';

interface ResultProps {

}

export class Results extends Component<ResultProps> {

    state = {
        keywordSubmit: {} as filter
    }

    renderContent = ( app: App ) => {
        const { subscription_required, subscription_id, per_page } = app.props.wpProps;
        let { criteria } = app.state;
        const { total, current_page, orderBy } = app.state;

        const textIndex = criteria.findIndex(filter => filter.type === 'text');
        const textFilter = criteria[textIndex];

        const onSubmitUsed = () => {
            criteria[textIndex].data.submit = false;
            app.setState({criteria});
        }

        if (textFilter.data.submit) {
            const data = textFilter.data.text !== '' ? cloneDeep(textFilter) : {};
            this.setState({keywordSubmit: data}, onSubmitUsed);
        }

        const onSelect = (event: React.ChangeEvent<HTMLSelectElement>) => {
            app.setState({orderBy: event.target.value}, app.query);
        }

        const onRemoveSelected = (crIndex: number, type: string, subAttr: string = null) => {
            if (type === 'text') {
                criteria[crIndex].data = {
                    text: '',
                    submit: false
                }
                this.setState({keywordSubmit: {}});
            } else if (type === 'date') {
                criteria[crIndex].date[subAttr] = null;
            } else {
                criteria[crIndex].terms[parseInt(subAttr)].checked = false;
            }
            app.setState({criteria, current_page: 1}, app.query);
        }

        const onReset = () => {
            app.removeLocalStorage();
            this.setState({keywordSubmit: {}}, app.init);
        }

        return (
            <div className="pbc-facet-results">
                <ResultControls total={total} perPage={per_page} currentPage={current_page} onSelect={onSelect} orderBy={orderBy}/>
                <ResultSelected criteria={criteria} keywordSubmit={this.state.keywordSubmit} onRemoveSelected={onRemoveSelected} onReset={onReset}/>
                {
                    subscription_required != 0 ?
                    <RestrictedView subscription={subscription_id} /> :
                    <AppContext.Provider value={app}>
                        <ResultGrid/>
                    </AppContext.Provider>

                }
            </div>
        )
    }

    render() {
        return (
            <AppContext.Consumer>
                {this.renderContent}
            </AppContext.Consumer>
        )
    }
}
